import React from 'react';
import styled from 'styled-components';

/* Components ---------------------------*/
import TaxTable from '../TaxTable/TaxTable';

const CalculatorOutput = ({inputValue, selectedData, tableData, location}) => {
    // curFormat applies USD currency formatting to any value added with minimumFractionDigits: 0 and maximumFractionDigits: 2
    const curFormat = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const calcTax = (income) => {

        const overValues = selectedData.map((values) => {
            return Number(values.over);
        });
        const baseTaxes = selectedData.map((tax) => {
            return Number(tax.baseTax);
        });
        const percentages = selectedData.map((percent) => {
            return Number(percent.percent);
        });
        const findBracket = overValues.filter((v, idx) => {
            return v == null ? idx : v >= income;
        })

        let totalTax = 0;
        let amountOver = 0;
        let baseTax = 0;
        let percentage = 0;
        let output = {
            totalTax: 0,
            baseTax: 0,
            incomeOver: 0,
            percentage: 0,
            amountOver: 0,
            notOver: 0
        }

        if(income <= overValues[0]){
            percentage = percentages[0];
            baseTax = baseTaxes[0];
            amountOver = 0;
        }else if(income >= (overValues[overValues.length - 2])){
            percentage = percentages[overValues.length - 1];
            baseTax = baseTaxes[overValues.length - 1];
            amountOver = overValues[overValues.length - 2];
        }else{
            const foundIndex = overValues.indexOf(findBracket[0]);
            percentage = percentages[foundIndex];
            baseTax = baseTaxes[foundIndex];
            amountOver = overValues[foundIndex - 1];
        }

        totalTax = baseTax + ((income - amountOver) * (percentage / 100));
        output = {...output,
            ...{
                totalTax: curFormat.format(totalTax),
                baseTax: baseTax,
                incomeOver: (income - amountOver),
                percentage: percentage,
                amountOver: curFormat.format(amountOver),
                notOver: curFormat.format(findBracket[0])
            }
        };

        return output;

    }

    const results = calcTax(inputValue);

    return (

        <CalculatorOutputStyled className='CalculatorOutput'>
            <div className={ results.totalTax == '$0.00' || results.totalTax == '$NaN' ? 'hidden' : 'visible' }>
                <p>Your income is over { results.amountOver } which makes your flat tax amount: { curFormat.format(results.baseTax) }.</p>
                <p>Percentage tax of excess for your bracket is: { results.percentage }%.</p>
                <p>You earned { curFormat.format(results.incomeOver) } over { results.amountOver }, resulting in an additional tax of { curFormat.format(results.incomeOver * (results.percentage / 100)) }.</p>
                <p className='location'>{ location } tax for your income of { curFormat.format(inputValue) } is:&nbsp; <strong>{ results.totalTax }</strong>.</p>
                <TaxTable data={ tableData } calcResult={ results.percentage } />
            </div>
        </CalculatorOutputStyled>
    );
}

export default CalculatorOutput;

const CalculatorOutputStyled = styled.div`
    margin-top: 35px;

    .hidden{
        display: none;
    }

    .location {
        padding-bottom: 25px;
    }

    .TaxTable {
        tr.rightBracket {
            td{
                background-color: #6dd49d;
            }
        }
    }

    @media (min-width: 768px) {
        p{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`;